import { assetDir } from '@common';
import $ from 'jquery';

class WelcomeScreen {
  constructor() {
  }

  add() {
    const tag = `
<div id="welcome">
  <div class="container">
    <img class="title" src="${assetDir}/images/opening_cover_txt.png" alt="明神山からタイムスリップ　世界遺産トラベル">
    <img class="tap-icon" src="${assetDir}/images/tap_icon.png">
  </div>
</div>
      `;
    $('body').append(tag.trim());
    return this;
  }

  waitForTap() {
    const deferred = new $.Deferred();
    $('#welcome').on('click', () => {
      deferred.resolve(true);
    });
    $('#welcome .tap-icon').delay(3000).queue(function () {
      $(this).addClass('play');
    });
    return deferred.promise();
  }

  remove() {
    $('#welcome').remove();
  }

}

export default new WelcomeScreen();